import { useAuth } from '../lib/auth';
import { IcMenu } from './icons';

export const AppHeader = ({ onMenuClick }: { onMenuClick?: () => void }) => {
  const { user } = useAuth();

  return (
    <header
      style={{
        height: 56,
        flexShrink: 0,
        borderBottom: '1px solid var(--p-border)',
        background: 'rgba(255,255,255,.8)',
        backdropFilter: 'blur(6px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 12,
        padding: '0 16px',
        fontFamily: 'var(--font-product)',
      }}
    >
      <button
        type="button"
        className="app-menu-btn"
        aria-label="Open navigation"
        onClick={onMenuClick}
      >
        <IcMenu size={18} />
      </button>
      <span
        style={{
          fontSize: 14,
          color: 'var(--p-muted-fg)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '60vw',
        }}
      >
        {user?.email}
      </span>
    </header>
  );
};
